import React, { useEffect, useRef, useState } from 'react';
import { Button, Col, Form, Input, InputGroup, InputGroupText, Row, Spinner } from "reactstrap";
import { useForm } from "react-hook-form";

import {
    ASSIGN_PRICES,
    CURRENCY_MXN_HEADER,
    CURRENCY_USD_HEADER,
    error,
    infoMsg,
    SAVE,
    saveMsg,
    success,
} from "../i18n/i18n";
import { ButtonCancel } from "../buttons/buttonsActions";
import {dishDrinkPriceService} from "../../jwt/_services/ayb/dishDrinkPriceService";
import {showToastCustom} from "../toast/customToast";

export const ConfirmAssignTreatmentPriceForm = ({ item, fbDataBaseId, onClose, updateList, durationOptions }) => {

    const [saving, setSaving] = useState(false);
    const [prices, setPrices] = useState(item.prices || []);

    const currencies = ['USD', 'MXN']

    const {register, handleSubmit } = useForm({
        defaultValues: {
        }
    });

    const isMounted = useRef(true)

    //Actualizar la referencia
    useEffect(() => {
        return () => {
            isMounted.current = false
        }
    },[])

    const onSubmit = (values, _) => {
        const dataRequest = {
            fbDataBase :  { id : fbDataBaseId },
            item : {
                items : prices
            }
        }

        setSaving(true)
        dishDrinkPriceService.saveItem(dataRequest)
            .then(result => {
                if(!result?.status)
                    return

                showToastCustom(success, saveMsg);
                onClose();
            })
            .catch( e => {
                    console.log("Error en la asignacion", e);
                    showToastCustom(error, infoMsg, true);
                }
            )
            .finally(() => {
                if(isMounted.current) {
                    setSaving(false)
                }
                updateList()
                onClose()
            });
    }

    const getPriceOf = (duration, currency) => {
        const price = prices.find(p => p.presentationType === duration && p.currencyCode === currency )

        return price?.price || 0.00
    }

    const setPriceOf = (duration, currency, value) => {
        const priceIndex = prices.findIndex(p => p.presentationType === duration && p.currencyCode === currency )
        const _prices = prices.slice();

        if (priceIndex !== -1) {
            _prices[priceIndex] = {
                ..._prices[priceIndex],
                price : value
            }
        } else {
            _prices.push({
                currency : { currency : currency },
                currencyCode : currency ,
                dishDrink : { id : item.id },
                presentationType : duration,
                price : value
            })
        }

        setPrices(_prices);
    }

    return (
        <div className='custom-ui-auto-width'>
            <h1>{ASSIGN_PRICES}</h1>

            <br/>
            <div style={{textAlign:'left'}}>
                <Form onSubmit={ handleSubmit(onSubmit) }>
                    <Row>
                        <Col md={"4"}/>
                        {
                            currencies.map((currency) => {
                                return (
                                    <Col md={"4"}><h4 style={ {textAlign:'center'} }>{ currency === 'USD' ? CURRENCY_USD_HEADER : CURRENCY_MXN_HEADER}</h4></Col>
                                );
                            })
                        }
                    </Row>
                    {
                        durationOptions.map((option) => {
                            return (
                                <Row>
                                    <Col md={"4"}>{ option.id + ' mins' }</Col>
                                    {
                                        currencies.map((currency) => {
                                            return (
                                                <Col md={"4"} style={ { borderRight:'solid' } }>
                                                    <InputGroup>
                                                        <InputGroupText>$</InputGroupText>
                                                        <Input
                                                            type="number"
                                                            step=".01"
                                                            min="0.00"
                                                            value={ getPriceOf(option.id, currency) }
                                                            onChange={e => setPriceOf(option.id, currency, e.target.value)}
                                                            placeholder={''}
                                                            innerRef={register}
                                                        />
                                                    </InputGroup>
                                                </Col>
                                            );
                                        })
                                    }
                                </Row>
                            );
                        })
                    }

                    <br/>
                    <br/>

                    <div style={{textAlign:'center'}}>
                        <ButtonCancel onClick={onClose}/>
                        &nbsp;&nbsp;
                        <Button
                            type={"submit"}
                            className="btn-add ml-auto ml-2"
                            disabled={ saving }
                        >
                            { SAVE }
                        </Button>
                        {
                            saving && <>
                                <br/><br/>
                                <Spinner animation="border" size='sm' type='grow'/>
                                <Spinner animation="border" size='sm' type='grow'/>
                                <Spinner animation="border" size='sm' type='grow'/>
                            </>
                        }
                    </div>
                </Form>
            </div>
        </div>
    );
}